import React, { Component } from "react";
import ZypeSteps from "./ZypeSteps/ZypeSteps";

export class ZypeModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.ZypeModal = this;
  }
  render() {
    let { props } = this;
    let {
      id,
      title,
      show,
      onClose,
      modalSize,
      logsData,
      logsColumns,
      handleSubmit,
      setGoSteps,
      goSteps,
      editData,
    } = props;

    return (
      <AppCanvas
        id={id}
        title={title}
        show={show}
        onClose={onClose}
        modalSize={modalSize}
        backdrop="static"
        className="profile-canvas"
      >
        <ZypeSteps
          handleSubmit={(...args) => handleSubmit(...args)}
          setGoSteps={setGoSteps}
          goSteps={goSteps}
          onClose={onClose}
          editData={editData}
        />
      </AppCanvas>
    );
  }
}

export default ZypeModal;
